import React from 'react';
import { FormControl, FormLabel, Switch, Select } from '@chakra-ui/react';

const LocationLangTargeting = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>Location Targeting Status</FormLabel>
        <Switch
          name="actionProps.locationAndSystemTargeting.status"
          isChecked={formik.values.actionProps.locationAndSystemTargeting.status}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Global Operator</FormLabel>
        <Select
          name="actionProps.locationAndSystemTargeting.globalOperator"
          value={formik.values.actionProps.locationAndSystemTargeting.globalOperator}
          onChange={formik.handleChange}
        >
          <option value="AND">AND</option>
          <option value="OR">OR</option>
        </Select>
      </FormControl>
      {/* Add dynamic list for criteria if needed */}
    </>
  );
};

export default LocationLangTargeting;